// E-commerce Mock Data

// Extended Products with more details
export const products = [
  {
    id: 1,
    name: "Wilifread Diamond Plus",
    brand: "Wilifread",
    capacity: "8L",
    technology: "RO + UV + UF + TDS",
    price: 17999,
    originalPrice: 22999,
    discount: 22,
    image: "https://customer-assets.emergentagent.com/job_b05cbb40-8fa7-4d6a-84f8-8343aaed5aff/artifacts/wg1xmlgc_9.png",
    images: [
      "https://customer-assets.emergentagent.com/job_b05cbb40-8fa7-4d6a-84f8-8343aaed5aff/artifacts/wg1xmlgc_9.png",
      "https://customer-assets.emergentagent.com/job_b05cbb40-8fa7-4d6a-84f8-8343aaed5aff/artifacts/r0a4z9tc_1.png"
    ],
    features: ["Zero Water Wastage", "Multiple Purification", "8L Storage", "TDS Controller", "UV LED Indicator"],
    specifications: {
      purification: "RO + UV + UF + TDS",
      capacity: "8 Liters",
      warranty: "1 Year",
      powerConsumption: "60W",
      storageType: "Food Grade Plastic"
    },
    inStock: true,
    rating: 4.5,
    reviews: 234,
    description: "Kent Grand Plus RO water purifier with advanced 4-stage purification technology. Zero water wastage technology ensures efficient water usage."
  },
  {
    id: 2,
    name: "Aquaguard Delight",
    brand: "Aquaguard",
    capacity: "7L",
    technology: "RO + UV + MTDS",
    price: 14499,
    originalPrice: 18999,
    discount: 24,
    image: "https://images.unsplash.com/photo-1563207153-f403bf289096?w=800&h=800&fit=crop",
    images: [
      "https://images.unsplash.com/photo-1563207153-f403bf289096?w=800&h=800&fit=crop",
      "https://images.unsplash.com/photo-1550167991-4879a6aa6b87?w=800&h=800&fit=crop"
    ],
    features: ["Energy Saving", "Smart LED Indicators", "Compact Design", "Mineral Guard", "Taste Adjuster"],
    specifications: {
      purification: "RO + UV + MTDS",
      capacity: "7 Liters",
      warranty: "1 Year",
      powerConsumption: "50W",
      storageType: "ABS Food Grade Plastic"
    },
    inStock: true,
    rating: 4.3,
    reviews: 189,
    description: "Aquaguard Delight with advanced purification and energy-saving technology. Compact design perfect for modern kitchens."
  },
  {
    id: 3,
    name: "Livpure Glo",
    brand: "Livpure",
    capacity: "7L",
    technology: "RO + UV + Mineralizer",
    price: 12999,
    originalPrice: 16999,
    discount: 24,
    image: "https://images.unsplash.com/photo-1550167991-4879a6aa6b87?w=800&h=800&fit=crop",
    images: [
      "https://images.unsplash.com/photo-1550167991-4879a6aa6b87?w=800&h=800&fit=crop",
      "https://images.unsplash.com/photo-1603531564509-f536e681e63a?w=800&h=800&fit=crop"
    ],
    features: ["Taste Enhancer", "7 Stage Purification", "Wall Mounted", "Mineralizer", "Auto Shut-off"],
    specifications: {
      purification: "RO + UV + Mineralizer",
      capacity: "7 Liters",
      warranty: "1 Year",
      powerConsumption: "55W",
      storageType: "Food Grade Plastic"
    },
    inStock: true,
    rating: 4.4,
    reviews: 156,
    description: "Livpure Glo with 7-stage purification and mineralizer for healthy, great-tasting water."
  },
  {
    id: 4,
    name: "Blue Star Aristo",
    brand: "Blue Star",
    capacity: "6L",
    technology: "RO + UV",
    price: 11499,
    originalPrice: 14999,
    discount: 23,
    image: "https://images.unsplash.com/photo-1603531564509-f536e681e63a?w=800&h=800&fit=crop",
    images: [
      "https://images.unsplash.com/photo-1603531564509-f536e681e63a?w=800&h=800&fit=crop",
      "https://images.unsplash.com/photo-1582719471384-894fbb16e074?w=800&h=800&fit=crop"
    ],
    features: ["3x Copper Purification", "Interactive LED Interface", "Sterilization", "Smart Display", "8L Large Capacity"],
    specifications: {
      purification: "RO + UV + Copper",
      capacity: "8 Liters",
      warranty: "1 Year",
      powerConsumption: "48W",
      storageType: "ABS Food Grade Plastic"
    },
    inStock: true,
    rating: 4.2,
    reviews: 143,
    description: "Wilifread Dream with interactive digital LED interface and copper purification. Large 8L capacity with advanced sterilization."
  },
  {
    id: 5,
    name: "Wilifread Dream Black",
    brand: "Wilifread",
    capacity: "8L",
    technology: "RO + UV + Copper",
    price: 15999,
    originalPrice: 19999,
    discount: 20,
    image: "https://customer-assets.emergentagent.com/job_b05cbb40-8fa7-4d6a-84f8-8343aaed5aff/artifacts/fleynbw0_13.png",
    images: [
      "https://customer-assets.emergentagent.com/job_b05cbb40-8fa7-4d6a-84f8-8343aaed5aff/artifacts/fleynbw0_13.png"
    ],
    features: ["3x Copper Infusion", "Interactive Smart Display", "8L Premium Capacity", "Digital LED Interface", "Sterilization Technology"],
    specifications: {
      purification: "RO + UV + Copper",
      capacity: "8 Liters",
      warranty: "1 Year",
      powerConsumption: "60W",
      storageType: "Food Grade Plastic with Copper"
    },
    inStock: true,
    rating: 4.6,
    reviews: 278,
    description: "Wilifread Dream Black with premium copper infusion and interactive LED interface. Elegant black design with copper accent strip for superior aesthetics."
  }
];

// Spare Parts
export const spareParts = [
  {
    id: 101,
    name: "Sediment Filter (Spun)",
    category: "Pre-Filters",
    compatibility: ["Kent", "Aquaguard", "Livpure", "Blue Star", "Pureit"],
    price: 199,
    originalPrice: 299,
    image: "https://images.unsplash.com/photo-1621905251189-08b45d6a269e?w=400&h=400&fit=crop",
    inStock: true,
    description: "5 Micron sediment filter for removing dirt, dust, and particles",
    lifespan: "3-6 months"
  },
  {
    id: 102,
    name: "Carbon Filter (Pre)",
    category: "Pre-Filters",
    compatibility: ["Kent", "Aquaguard", "Livpure", "Blue Star", "Pureit"],
    price: 249,
    originalPrice: 349,
    image: "https://images.unsplash.com/photo-1621905251189-08b45d6a269e?w=400&h=400&fit=crop",
    inStock: true,
    description: "Activated carbon filter for removing chlorine, odor, and taste",
    lifespan: "6-9 months"
  },
  {
    id: 103,
    name: "RO Membrane (75 GPD)",
    category: "Main Filters",
    compatibility: ["Kent", "Aquaguard", "Livpure"],
    price: 1299,
    originalPrice: 1699,
    image: "https://images.unsplash.com/photo-1621905251189-08b45d6a269e?w=400&h=400&fit=crop",
    inStock: true,
    description: "High-quality RO membrane for effective water purification",
    lifespan: "12-18 months"
  },
  {
    id: 104,
    name: "RO Membrane (80 GPD)",
    category: "Main Filters",
    compatibility: ["Blue Star", "Pureit"],
    price: 1399,
    originalPrice: 1799,
    image: "https://images.unsplash.com/photo-1621905251189-08b45d6a269e?w=400&h=400&fit=crop",
    inStock: true,
    description: "Premium RO membrane with higher flow rate",
    lifespan: "12-18 months"
  },
  {
    id: 105,
    name: "Post Carbon Filter",
    category: "Post-Filters",
    compatibility: ["Kent", "Aquaguard", "Livpure", "Blue Star", "Pureit"],
    price: 299,
    originalPrice: 399,
    image: "https://images.unsplash.com/photo-1621905251189-08b45d6a269e?w=400&h=400&fit=crop",
    inStock: true,
    description: "Final stage carbon filter for taste enhancement",
    lifespan: "6-12 months"
  },
  {
    id: 106,
    name: "UV Lamp 11W",
    category: "UV Components",
    compatibility: ["Kent", "Aquaguard", "Livpure"],
    price: 799,
    originalPrice: 999,
    image: "https://images.unsplash.com/photo-1621905251189-08b45d6a269e?w=400&h=400&fit=crop",
    inStock: true,
    description: "UV sterilization lamp for killing bacteria and viruses",
    lifespan: "12 months"
  },
  {
    id: 107,
    name: "Booster Pump",
    category: "Accessories",
    compatibility: ["Universal"],
    price: 1499,
    originalPrice: 1899,
    image: "https://images.unsplash.com/photo-1621905251189-08b45d6a269e?w=400&h=400&fit=crop",
    inStock: true,
    description: "High-pressure booster pump for low water pressure areas",
    lifespan: "24-36 months"
  },
  {
    id: 108,
    name: "SMPS (Power Adapter)",
    category: "Accessories",
    compatibility: ["Kent", "Aquaguard", "Livpure", "Blue Star"],
    price: 599,
    originalPrice: 799,
    image: "https://images.unsplash.com/photo-1621905251189-08b45d6a269e?w=400&h=400&fit=crop",
    inStock: true,
    description: "Switching mode power supply for RO purifiers",
    lifespan: "24 months"
  },
  {
    id: 109,
    name: "Complete Service Kit",
    category: "Service Kits",
    compatibility: ["Kent Grand Plus", "Kent Supreme"],
    price: 2499,
    originalPrice: 3299,
    image: "https://images.unsplash.com/photo-1621905251189-08b45d6a269e?w=400&h=400&fit=crop",
    inStock: true,
    description: "Complete filter replacement kit with all essential filters",
    lifespan: "12 months"
  },
  {
    id: 110,
    name: "Inline Filter Set (3 pcs)",
    category: "Filter Combos",
    compatibility: ["Universal"],
    price: 599,
    originalPrice: 799,
    image: "https://images.unsplash.com/photo-1621905251189-08b45d6a269e?w=400&h=400&fit=crop",
    inStock: true,
    description: "Set of 3 inline filters - sediment, carbon pre, carbon post",
    lifespan: "6 months"
  },
  {
    id: 111,
    name: "TDS Controller",
    category: "Accessories",
    compatibility: ["Kent", "Livpure"],
    price: 899,
    originalPrice: 1199,
    image: "https://images.unsplash.com/photo-1621905251189-08b45d6a269e?w=400&h=400&fit=crop",
    inStock: true,
    description: "TDS controller for maintaining essential minerals",
    lifespan: "24 months"
  },
  {
    id: 112,
    name: "Storage Tank 12L",
    category: "Accessories",
    compatibility: ["Universal"],
    price: 1799,
    originalPrice: 2299,
    image: "https://images.unsplash.com/photo-1621905251189-08b45d6a269e?w=400&h=400&fit=crop",
    inStock: true,
    description: "Food-grade plastic storage tank for RO purifiers",
    lifespan: "60 months"
  }
];

export const categories = {
  spareParts: [
    { id: "all", name: "All Parts", count: 12 },
    { id: "pre-filters", name: "Pre-Filters", count: 2 },
    { id: "main-filters", name: "Main Filters", count: 2 },
    { id: "post-filters", name: "Post-Filters", count: 1 },
    { id: "uv-components", name: "UV Components", count: 1 },
    { id: "accessories", name: "Accessories", count: 4 },
    { id: "service-kits", name: "Service Kits", count: 1 },
    { id: "filter-combos", name: "Filter Combos", count: 1 }
  ]
};

export const brands = ["Kent", "Aquaguard", "Livpure", "Blue Star", "Pureit", "Universal"];

// Services remain the same
export const services = [
  {
    id: 1,
    title: "RO Installation",
    description: "Professional installation of RO water purifiers with warranty. Expert technicians ensure proper setup for optimal performance.",
    icon: "Droplets",
    price: "Starting from ₹500"
  },
  {
    id: 2,
    title: "RO Repair & Service",
    description: "Quick repair services for all brands. We fix leakage, low water flow, bad taste, and all RO issues.",
    icon: "Wrench",
    price: "Starting from ₹300"
  },
  {
    id: 3,
    title: "AMC Packages",
    description: "Annual Maintenance Contract with regular servicing, free filter cleaning, and priority support.",
    icon: "Shield",
    price: "Starting from ₹1,999/year"
  },
  {
    id: 4,
    title: "Filter Replacement",
    description: "Genuine filters for all RO brands. Sediment, carbon, RO membrane, and post-carbon filters available.",
    icon: "Filter",
    price: "Starting from ₹400"
  },
  {
    id: 5,
    title: "Water Testing",
    description: "Free water quality testing with TDS meter. Know your water quality before choosing the right purifier.",
    icon: "TestTube",
    price: "Free"
  },
  {
    id: 6,
    title: "Emergency Service",
    description: "24/7 emergency repair service available. Same-day service for urgent issues in Jaipur.",
    icon: "Clock",
    price: "Call for details"
  }
];

export const testimonials = [
  {
    id: 1,
    name: "Rajesh Sharma",
    location: "Malviya Nagar, Jaipur",
    rating: 5,
    text: "Excellent service! They repaired my RO within 2 hours. Very professional and affordable. Highly recommended!",
    date: "2 days ago"
  },
  {
    id: 2,
    name: "Priya Verma",
    location: "Vaishali Nagar, Jaipur",
    rating: 5,
    text: "Got my new Kent RO installed from RO Dekho. Great service and the technician explained everything clearly.",
    date: "1 week ago"
  },
  {
    id: 3,
    name: "Amit Singh",
    location: "Mansarovar, Jaipur",
    rating: 5,
    text: "Best AMC package in Jaipur! Regular maintenance and genuine spare parts. Very satisfied with their service.",
    date: "2 weeks ago"
  },
  {
    id: 4,
    name: "Sunita Gupta",
    location: "Jagatpura, Jaipur",
    rating: 5,
    text: "Quick response and honest pricing. Fixed the leakage issue in my RO perfectly. Will definitely call again!",
    date: "3 weeks ago"
  }
];

export const whyChooseUs = [
  {
    id: 1,
    title: "Expert Technicians",
    description: "Certified and experienced professionals for all RO brands",
    icon: "UserCheck"
  },
  {
    id: 2,
    title: "Genuine Parts",
    description: "100% authentic spare parts and filters with warranty",
    icon: "BadgeCheck"
  },
  {
    id: 3,
    title: "Quick Service",
    description: "Same-day service available across Jaipur",
    icon: "Zap"
  },
  {
    id: 4,
    title: "Affordable Pricing",
    description: "Transparent and competitive pricing with no hidden charges",
    icon: "IndianRupee"
  },
  {
    id: 5,
    title: "Warranty Support",
    description: "Service warranty on all repairs and installations",
    icon: "Award"
  },
  {
    id: 6,
    title: "24/7 Support",
    description: "Round-the-clock customer support and emergency service",
    icon: "Phone"
  }
];

export const serviceAreas = [
  "Malviya Nagar", "Vaishali Nagar", "Mansarovar", "Jagatpura",
  "Pratap Nagar", "Raja Park", "C-Scheme", "MI Road",
  "Tonk Road", "Ajmer Road", "Sikar Road", "JLN Marg"
];

export const faqs = [
  {
    id: 1,
    question: "How often should I service my RO water purifier?",
    answer: "We recommend servicing your RO every 3-4 months for optimal performance. Regular servicing includes filter cleaning, membrane check, and sanitization."
  },
  {
    id: 2,
    question: "Do you provide service for all RO brands?",
    answer: "Yes, we service all major brands including Kent, Aquaguard, Livpure, Blue Star, Pureit, and more. Our technicians are trained for multi-brand support."
  },
  {
    id: 3,
    question: "What is included in the AMC package?",
    answer: "Our AMC includes 4 free services per year, filter cleaning, membrane check, sanitization, and priority support with discounted spare parts."
  },
  {
    id: 4,
    question: "How quickly can you respond to service requests?",
    answer: "We provide same-day service for most areas in Jaipur. Emergency services are available 24/7 with technician dispatch within 2-4 hours."
  },
  {
    id: 5,
    question: "Do you offer warranty on repairs?",
    answer: "Yes, all our repair services come with a 30-day service warranty. Spare parts have manufacturer warranty as applicable."
  }
];
